import type { Components, Theme } from "@mui/material/styles";

export const MuiTypography: Components<Theme>["MuiTypography"] = {
  styleOverrides: {
    h1: ({ theme }) => ({
      fontSize: theme.typography.fontSizeXxl,
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: 1.3333,
      letterSpacing: "-0.75px",
    }),
    h2: ({ theme }) => ({
      fontSize: theme.typography.fontSizeXl,
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: 1.3333,
      letterSpacing: "-0.25px",
    }),
    h3: ({ theme }) => ({
      fontSize: theme.typography.fontSizeLg,
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: 1.5,
      letterSpacing: 0,
    }),
    h4: ({ theme }) => ({
      fontSize: theme.typography.fontSizeMd,
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: 1.42857,
      letterSpacing: 0,
    }),
    h5: ({ theme }) => ({
      fontSize: theme.typography.fontSizeSm,
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: 1.3333,
      letterSpacing: "0.25px",
    }),
    h6: ({ theme }) => ({
      fontSize: theme.typography.fontSizeXs,
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: 1.6,
      letterSpacing: "0.5px",
    }),
    subtitle1: ({ theme }) => ({
      fontSize: theme.typography.fontSizeMd,
      fontWeight: theme.typography.fontWeightBold,
      lineHeight: 1.5,
      letterSpacing: "0.25px",
    }),
    subtitle2: ({ theme }) => ({
      fontSize: theme.typography.fontSizeSm,
      fontWeight: theme.typography.fontWeightBold,
      lineHeight: 1.333,
      letterSpacing: "0.25px",
    }),
    body1: ({ theme }) => ({
      fontSize: theme.typography.fontSizeMd,
      fontWeight: theme.typography.fontWeightRegular,
      lineHeight: 1.4286,
      letterSpacing: 0,
    }),
    body2: ({ theme }) => ({
      fontSize: theme.typography.fontSizeSm,
      fontWeight: theme.typography.fontWeightRegular,
      lineHeight: 1.4286,
      letterSpacing: 0,
    }),
    caption: ({ theme }) => ({
      fontSize: theme.typography.fontSizeSm,
      fontWeight: theme.typography.fontWeightRegular,
      lineHeight: 1.3333,
      letterSpacing: "0.25px",
    }),
    overline: ({ theme }) => ({
      fontSize: theme.typography.fontSizeSm,
      fontWeight: theme.typography.fontWeightBold,
      lineHeight: 1.3333,
      letterSpacing: "0.75px",
      textTransform: "uppercase",
    }),
  },
};
